/**
 * Unit price on a change request line is locked to the bid sheet whenever the
 * line references (or is typed against) an item that already exists there.
 * Pending new items keep an editable, shared price.
 */
export function isUnitPriceLocked(
  itemNo: string | null | undefined,
  bidItemId: number | string | null | undefined,
  bidItems: { item?: string }[] = [],
): boolean {
  if (bidItemId) {
    return true;
  }
  const key = String(itemNo ?? '').trim();
  if (!key) {
    return false;
  }
  return bidItems.some(b => String(b?.item ?? '').trim() === key);
}

/**
 * A request_no is stored as its number followed by the request title
 * ("10 Expand mitigation pond"). The hint under a form field has room for one
 * line, so only the leading number token is shown. Request numbers that don't
 * start with digits (e.g. "CR-7") are kept whole.
 */
export function shortRequestNo(requestNo: string | null | undefined): string {
  const value = String(requestNo ?? '').trim();
  if (!value) {
    return '';
  }
  const match = /^(\d+[A-Za-z]?)(?=[\s\-–—.:]|$)/.exec(value);
  return match ? match[1] : value;
}

export function sharedPriceHint(
  itemNo: string | null | undefined,
  pendingItems: { item_no?: string; request_nos?: string[] }[] = [],
): string {
  const key = String(itemNo ?? '').trim();
  const match = pendingItems.find(p => String(p?.item_no ?? '').trim() === key);
  if (!match?.request_nos?.length) {
    return '';
  }
  const numbers = match.request_nos.map(shortRequestNo).join(', ');
  return `Shared price with request${match.request_nos.length === 1 ? '' : 's'} ${numbers}`;
}
